import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const FeatureItems = [
    {
        title: 'Tech Driven Learning',
        info: 'Dive into immerse in VR classrooms, AI-driven pathways, and gamified modules for an interactive and personalized learning journey.',
        image: 'feature-image-01.webp',
        bgColor: 'card-bg-1',
        link: '#'
    },
    {
        title: 'Community Colaborations',
        info: 'Engage in peer discussions, group projects, and co-creation opportunities to foster knowledge exchange and collective growth.',
        image: 'feature-image-02.webp',
        bgColor: 'card-bg-2',
        link: '#'
    },
    {
        title: 'Future Education',
        info: 'Stay ahead with emerging technologies and pedagogical approaches, ensuring readiness for tomorrows challenges and opportunities.',
        image: 'feature-image-03.webp',
        bgColor: 'card-bg-3',
        link: '#'
    },
    {
        title: 'Innovative Learning',
        info: 'Experience a dynamic shift from conventional methods, transforming education through innovation, collaboration, and continuous evolution.',
        image: 'feature-image-04.webp',
        bgColor: 'card-bg-4',
        link: '#'
    }
];

const FeatureOne = ( { wrapperClass, alignment, style } ) => {
    return (
        <div className={ `row ${ wrapperClass || 'g-5 mt--20' }` }>
            { FeatureItems.map( ( data , i ) => (
                <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    className={ `col-lg-3 col-md-6 col-12 ${ alignment ? alignment : '' } ${ style ? style : '' }` }
                    animateOnce={ true }
                    key={ i }
                >
                    <div className={ `service-card service-card-2 ${ data.bgColor }` }>
                        <div className="inner">
                            <div className="icon">
                                <a href={ data.link }>
                                    <img src={`${process.env.PUBLIC_URL}/images/feature/feature-01/${ data.image }`} alt="Feature Thumb" width="40" height="40" loading="lazy"/>
                                </a>
                                <div className="shape-list">
                                    <img className="shape shape-1" src="/images/feature/feature-01/feature-icon-01.webp" alt="Shape Particle" width="8" height="9" loading="lazy"/>
                                    <img className="shape shape-2" src="/images/feature/feature-01/feature-icon-02.webp" alt="Shape Particle" width="10" height="10" loading="lazy"/>
                                    <img className="shape shape-3" src="/images/feature/feature-01/feature-icon-03.webp" alt="Shape Particle" width="12" height="11" loading="lazy"/>
                                </div>
                            </div>
                            <div className="content">
                                <h6 className="title"><a href={ data.link }>{ data.title }</a></h6>
                                <p className="description">{ data.info }</p>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            ) ) }
        </div>
    )
}

export default FeatureOne;